import { orchestrator } from 'satcheljs';
import { initializeRefreshUpNextPoll, cancelRefreshUpNextPoll } from '../actions/internalActions';
import { poll, cancelPoll } from 'owa-request-manager';
import { refreshUpNextCalendarEvent } from './checkRefreshUpNextCalendarEvent';

const REFRESH_UP_NEXT_INTERVAL = 10000;

orchestrator(initializeRefreshUpNextPoll, actionMessage => {
    const { folderIds, scenarioId } = actionMessage;

    /** Refresh the up next calendar event on an interval so that the up next
     * event stays up to date as time progresses */
    poll(
        () => {
            return refreshUpNextCalendarEvent(folderIds, scenarioId);
        },
        scenarioId,
        REFRESH_UP_NEXT_INTERVAL
    );
});

orchestrator(cancelRefreshUpNextPoll, actionMessage => {
    cancelPoll(actionMessage.scenarioId);
});
